

import _util from '../../utils/';

const approvalCenter = {
    fetchApprovalPending (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/ApprovalPending',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchCcToMe (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/CcToMe',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchApproved (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/Approved',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchApprovedCustom (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/ApprovedCustom',
            params: params,
            success: resolve,
            error: reject
        })
    },

    fetchApproval (posts, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/Approval',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });
    },
    fetchALLApproval (posts, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/BatchApproval',
            method: 'post',
            data: posts,
            success: resolve,
            error: reject
        });
    },
    //手机加班审批
    fetchOvertimeApprovalPending (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/ApprovalPending?document_category=3',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchOvertimeCcToMe (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/CcToMe?document_category=3',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchOvertimeApproved (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/Approved?document_category=3',
            params: params,
            success: resolve,
            error: reject
        })
    },
    //手机调休审批
    fetchBreakDownApprovalPending (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/ApprovalPending?document_category=2',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchBreakDownCcToMe (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/CcToMe?document_category=2',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchBreakDownApproved (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/Approved?document_category=2',
            params: params,
            success: resolve,
            error: reject
        })
    },
    //手机请假审批
    fetchLeaveApprovalPending (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/ApprovalPending?document_category=1',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchLeaveCcToMe (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/CcToMe?document_category=1',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchLeaveApproved (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/Approved?document_category=1',
            params: params,
            success: resolve,
            error: reject
        })
    },
    //手机外出审批
    fetchGoOutApprovalPending (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/ApprovalPending?document_category=4',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchGoOutCcToMe (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/CcToMe?document_category=4',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchGoOutApproved (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/Approved?document_category=4',
            params: params,
            success: resolve,
            error: reject
        })
    },
    //手机出差审批
    fetchBusinessApprovalPending (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/ApprovalPending?document_category=5',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchBusinessCcToMe (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/CcToMe?document_category=5',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchBusinessApproved (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/Approved?document_category=5',
            params: params,
            success: resolve,
            error: reject
        })
    },
    //手机考勤申诉审批
    fetchComplainApprovalPending (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/ApprovalPending?isComplain=true',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchComplainCcToMe (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/CcToMe?isComplain=true',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchComplainApproved (params, resolve, reject) {
        _util.request({
            url: '/api/ApprovalCenter/Approved?isComplain=true',
            params: params,
            success: resolve,
            error: reject
        })
    },
    // 审批流获取
    fetchApprovalFlowLog(gets, resolve, reject) {
        _util.request({
            // url: '/api/HRApprovalFlowLog/GetLogWithStep',
            url: '/api/HRApprovalFlowLog/GetLogWithDocumentID',
            params: gets,
            success: resolve,
            error: reject
        })
    },
}


export default approvalCenter;


// WEBPACK FOOTER //
// ./src/services/Employee/approval-center-service.js